"use strict";

var WORDS_PER_MINUTE = 275;

function wordCountToReadingTime() {
  var wordCount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

  return Math.ceil(wordCount / WORDS_PER_MINUTE);
}

module.exports = wordCountToReadingTime;